<template>
  <div class="index-newly container-build">
    <div class="container-head">
      <div class="head-left">
        <div class="icon">
          <img src="../../static/index/newly/newly-icon.png" />
        </div>
        初创必备
      </div>
      <!-- <div class="head-right" @click="gocompany">
        查看更多
        <div class="icon"></div>
      </div> -->
    </div>
    <div class="newly-list row">
      <div
        class="col-lg-4 col-xs-4"
        v-for="item in newly.slice(0, 3)"
        :key="item.id"
      >
        <div class="newly-item" @click="golink(item.linkUrl, item.actiontype)">
          <div class="item-title-1">{{ item.title }}</div>
          <div class="item-title-2">{{ item.subtitle }}</div>
          <div
            class="item-icon"
            :style="{ backgroundImage: 'url(' + item.imgUrl + ')' }"
          >
            <!-- <img :src="item.imgUrl" /> -->
          </div>
        </div>
      </div>

      <div
        class="col-lg-6 col-xs-6"
        v-for="item in newly.slice(3, 5)"
        :key="item.id"
      >
        <div class="newly-item-2" @click="golink(item.linkUrl)">
          <div class="item-title-1">{{ item.title }}</div>
          <div class="item-title-2">{{ item.subtitle }}</div>
          <div
            class="item-icon"
            :style="{ backgroundImage: 'url(' + item.imgUrl + ')' }"
          >
            <!-- <img :src="item.imgUrl" /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["newly"],
  data() {
    return {};
  },

  methods: {
    golink(url, actiontype) {
      if (actiontype == "page") {
        window.open(url, "_self");
      } else {
        window.open(url, "_blank");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.index-newly {
  margin: auto;
  flex-direction: column;

  .newly-list {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    display: flex;
    margin: 0;
    .col-lg-4 {
      padding: 0 0.05rem;
    }
    .col-lg-6 {
      padding: 0 0.05rem;
    }
    .newly-item {
      flex-direction: column;
      width: 100%;
      height: 2.04rem;
      background-color: #fff;
      box-shadow: 0px 0.02rem 0.1rem 0px rgba(54, 54, 54, 0.1);
      border-radius: 0.12rem;
      padding: 0.25rem 0;
      margin-bottom: 0.2rem;
      position: relative;
      text-align: center;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      .item-title-1 {
        color: #1b1c33;
        font-size: 0.2rem;
        line-height: 0.28rem;
        font-weight: 500;
        justify-content: center;
        margin-bottom: 0.05rem;
      }

      .item-title-2 {
        color: #5e5e66;
        font-size: 0.16rem;
        line-height: 0.22rem;
        justify-content: center;
      }

      .item-icon {
        //width: 1.4rem;
        width: 100%;
        height: 100%;
        justify-content: center;
        margin: auto;
        position: absolute;
        top: -0.1rem;
        left: 0;
        background-size: 1.38rem 1.08rem;
        background-repeat: no-repeat !important;
        background-position: center bottom !important;
        img {
          width: 100%;
          height: 100%;
        }
      }
      @media (max-width: 991px) {
        .item-title-1 {
          color: #1b1c33;
          font-size: 0.28rem;
          line-height: 0.36rem;
          font-weight: bolder;
          justify-content: center;
          margin-bottom: 0rem;
        }

        .item-title-2 {
          color: #5e5e66;
          font-size: 0.26rem;
          line-height: 0.3rem;
          justify-content: center;
        }
      }
    }

    .newly-item-2 {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 2.04rem;
      background-color: #fff;
      box-shadow: 0px 0.02rem 0.1rem 0px rgba(54, 54, 54, 0.1);
      border-radius: 0.12rem;
      padding: 0.25rem 0;
      margin-bottom: 0.2rem;
      position: relative;
      text-align: center;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .item-title-1 {
        color: #1b1c33;
        font-size: 0.2rem;
        line-height: 0.28rem;
        font-weight: 500;
        justify-content: left;
        margin-bottom: 0.1rem;
      }

      .item-title-2 {
        color: #5e5e66;
        font-size: 0.16rem;
        line-height: 0.22rem;
        justify-content: left;
      }

      .item-icon {
        width: 100%;
        height: 100%;
        justify-content: center;
        margin: auto;
        position: absolute;
        top: -0.1rem;
        left: 0;
        background-size: 1.38rem 1.08rem;
        background-repeat: no-repeat !important;
        background-position: center bottom !important;
        img {
          width: 100%;
          height: 100%;
        }
      }
      @media (max-width: 991px) {
        .item-title-1 {
          color: #1b1c33;
          font-size: 0.28rem;
          line-height: 0.36rem;
          font-weight: bolder;
          justify-content: center;
          margin-bottom: 0rem;
        }

        .item-title-2 {
          color: #5e5e66;
          font-size: 0.26rem;
          line-height: 0.3rem;
          justify-content: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/indexnewly.vue